import React, { useEffect } from "react";
import FileInput, { FileDetails } from "@amzn/meridian/file-input";
import {
  setFile,
  preProcessUploadNewRevision,
  resetPreProcessUploadNewRevisionError,
  resetUploadNewRevisionOutput,
  getCurrentGroundTruth,
  uploadNewRevision,
} from "src/store/modelLifeCycleSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { GROUND_TRUTH_UPLOAD_URL } from "src/store/modelLifeCycleGroundTruthSlice";
import { getFileInfoWithProperLength } from "src/utils/fileUtil";
import UploadNewRevisionModal from "src/components/pages/validationWorkflow/groundTruthFileUploadView/uploadNewRevisionModal";

const UploadNewRevision = () => {
  const {
    file,
    selectedUploadFileValues,
    preProcessUploadNewRevisionOutput,
    uploadNewRevisionOutput,
    preProcessUploadNewRevisionError,
  } = useAppSelector((state) => state.modelLifeCycleSlice);
  const { selectedModelId } = useAppSelector((state) => state.modelSlice);
  const { apiErrors } = useAppSelector((state) => state.errorBoundary);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetPreProcessUploadNewRevisionError());
    dispatch(setFile(null));
    dispatch(getCurrentGroundTruth({ modelId: selectedModelId }));
  }, [selectedModelId]);

  return (
    <React.Fragment>
      <FileInput
        type="single"
        accept=".csv"
        uploadButtonType="secondary"
        uploadButtonLabel="Upload ground truth to improve accuracy"
        onFileAttached={(acceptedFiles) => {
          dispatch(resetPreProcessUploadNewRevisionError());
          dispatch(resetUploadNewRevisionOutput());
          dispatch(setFile(acceptedFiles[0]));
          dispatch(
            preProcessUploadNewRevision({
              modelId: selectedModelId,
              file: acceptedFiles[0],
              groundTruthUploadFileValue: selectedUploadFileValues,
            }),
          );
        }}
      >
        {file && (
          <FileDetails
            file={getFileInfoWithProperLength(file)}
            cancelUploadButtonLabel={`Cancel, ${file.name}`}
            removeFileButtonLabel={`Delete, ${file.name}`}
            error={!!preProcessUploadNewRevisionError}
            errorMessage={apiErrors[GROUND_TRUTH_UPLOAD_URL]}
            uploadComplete={!!preProcessUploadNewRevisionError || !!uploadNewRevisionOutput}
          />
        )}
      </FileInput>
      <UploadNewRevisionModal></UploadNewRevisionModal>
    </React.Fragment>
  );
};
export default UploadNewRevision;
